<template>
    <div>

        <div class="alert alert-danger text-white" role="alert" :class="success === false ? 'show' : ''">
            <strong>Error!&nbsp;</strong> {{ message }}
        </div>

        <div class="alert alert-success text-white" role="alert" :class="success === true ? 'show' : ''">
            <strong>Success!&nbsp;</strong> {{message}}
        </div>

        <Loading />
    </div>
</template>

<script>
import Loading from "./Loading.vue";
import {mapActions, mapGetters} from "vuex";

export default {
    name: "Notifications",
    components: {Loading},
    computed: mapGetters({
        message: 'notifications/message',
        success: 'notifications/success',
    }),
    watch:{
        success (to, from){
            setTimeout(() => {
                this.clearNotifications()
            },6000)
        }
    },
    methods: {
        ...mapActions({
            clearNotifications: 'notifications/clearNotifications',
        }),
    }
}
</script>

<style scoped>
    .alert.show {
        bottom: 0;
    }
    .alert.alert-danger {
        background-color: #f04e4e;
    }
    .alert.alert-success {
        background-color: #6ebd26;
    }
    .alert{
        margin-bottom: 0;
        transition: .3s;
        position: fixed;
        bottom: -100px;
        text-align: center;
        color: white;
        width: 100%;
        left: 0;
        height: 46px;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99999;
    }
</style>